import React, {useState} from 'react'
import { Link } from 'react-scroll'
import Logo from './logo.png'
import { FaBars, FaTimes } from 'react-icons/fa'
import './Navbar.css'
import { IconContext } from 'react-icons/lib'
import { motion } from 'framer-motion'

function Navbar() {
    const [click, setClick] = useState(false)

    const handleClick = () => setClick(!click)

    return (
        <>
        <IconContext.Provider value={{color: '#d4d5dd'}}>
            <div className='navbar'>
                <div className='navbar-container'>
                    <Link to='Home' className='navbar-logo' onClick={handleClick} smooth={true} duration={1000}>
                        <img src={Logo} 
                            alt='logo' 
                            className='logo'
                        />
                    </Link>
                    <div className='navbar-menu-icon' onClick={handleClick}>
                        {click ? <FaTimes /> : <FaBars />}
                    </div>
                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                        <li className='nav-item' onClick={handleClick}>
                            <Link to='Home' className='nav-links' smooth={true} duration={1000}>
                                Home
                            </Link>
                        </li>
                        <li className='nav-item' onClick={handleClick}>
                            <Link to='About' className='nav-links' smooth={true} duration={1000}>
                                About
                            </Link>
                        </li>
                        <li className='nav-item' onClick={handleClick}>
                            <Link to='project' className='nav-links' smooth={true} duration={1000}>
                                Projects
                            </Link>
                        </li>
                        <li className='nav-item' onClick={handleClick}>
                            <Link to='services' className='nav-links' smooth={true} duration={1000}>
                                Services
                            </Link>
                        </li>
                        <li className='nav-item' onClick={handleClick}>
                            <Link to='contact' className='nav-links' smooth={true} duration={1000}>
                                Contact
                            </Link>
                        </li>

                    </ul>
                </div>
            </div> 
        </IconContext.Provider>           
        </>
    )
}

export default Navbar
